/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import React, { useState } from "react";
import { ContentfulNavItem } from "../../../graphql-types";
import NavItemChildren from "./nav-item-children";
import RockitLink from "../link/rockit-link";
import Chevron from "../design-elements/chevron";
import { useHover } from "../../hooks/on-hover";
import { useActiveLink } from "../../hooks/activeLink";
type NavItemProps = {
  item: ContentfulNavItem;
  isTopLevel: boolean;
  level: number;
  variant: string;
};
export const NavItem: React.FC<NavItemProps> = ({
  item,
  isTopLevel,
  level,
  variant,
}) => {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();
  const [showChild, setShowChild] = useState(false);

  

  /* there are multiple things a menu can link to (in order of low to High):
      - link (text field should only really be used for external URLs)
      - Collection
      - Product
      - Links To (Home Page || page builder)

*/
  let to = item.link;
  if (item.shopifyCollection) {
    to = `shop/${item.shopifyCollection.handle}`;
  }
  if (item.linksTo) {
    to = item.linksTo.slug;
  }

 const isActivePath = useActiveLink(to);

  //sort our padding out
  let yPadding = [2];
  if (isTopLevel) {
    if (variant === "nav.main") {
      yPadding = [2];
    } else {
      yPadding = [0];
    }
  }

  let xPadding = [0];
  if (isTopLevel) {
    if (variant === "nav.main") {
      xPadding = [0, 3];
    } else {
      xPadding = [2];
    }
  }

  return (
    <Flex
      ref={hoverRef}
      variant={
        item.isHighlight
          ? `${variant}.highlight${isActivePath ? ".active" : ""}`
          : `${variant}${isActivePath ? ".active" : ""}`
      }
      py={yPadding}
      as="li"
      px={xPadding}
      sx={{ flexDirection: ["column", "row"], minWidth: "auto" }}
      key={item.label}
      onClick={() => setShowChild(!showChild)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {!item.navItems ? (
          <RockitLink to={to} isNavLink={true}>
            {item.label}
          </RockitLink>
        ) : (
          <Box variant={item.isHighlight ? "xxx" : "xxx"}>{item.label}</Box>
        )}
        {isTopLevel && item.navItems && (
          <Chevron
            sx={{
              display: ["block", "none"],
              ml: 2,
              width: "10px",
              height: "10px",
              variant: showChild
                ? `${variant}.chevron.open`
                : `${variant}.chevron`,
            }}
          ></Chevron>
        )}
      </Box>

      {item.navItems && (
        <NavItemChildren
          navItems={item.navItems}
          visible={showChild || isHovered}
          level={level + 1}
          variant={variant}
        />
      )}
    </Flex>
  );
};

/*
     <Box sx={{ display: "flex", alignItems: "center" }}>
        {!item.navItems ? (
          <RockitLink to={to} isNavLink={true}>
            {item.label}
          </RockitLink>
        ) : (
          <Box variant={item.isHighlight ? "xxx" : "xxx"}>{item.label}</Box>
        )}
        {isTopLevel && item.navItems && (
          <Chevron
            sx={{
              ml: 2,
              width: "10px",
              height: "10px",
              variant: expanded
                ? `${variant}.chevron.open`
                : `${variant}.chevron`,
            }}
          ></Chevron>
        )}
      </Box>

      {item.navItems && (
        <NavItemChildren
          navItems={item.navItems}
          visible={expanded}
          level={level + 1}
          variant={variant}
        />
      )}


*/
